import Log from "../utils/Log";
import { createUserDownloadsRequest } from "../api/analytics";
import { DownloadPlatforms } from "../reducers/models";
import { BBDownloadVersion } from "../shared/utility";

// AP: Google Client Id should be available (if possible) before calling this function
export const downloadBuildboxClient = (platformDesired, version) => {
  return new Promise((resolve) => {
    if (!platformDesired) {
      // try to auto detect platform from browser
      const platform = window.navigator.platform;

      if (platform) {
        const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
        const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];

        const foundMatch = (str) => str.includes(platform);
        if (windowsPlatforms.some(foundMatch)) {
          platformDesired = DownloadPlatforms.WINDOWS;
        } else if (macosPlatforms.some(foundMatch)) {
          platformDesired = DownloadPlatforms.MAC;
        } else {
          Log.warn(
            "unable to automatically determine download platform from ",
            platform
          );
          platformDesired = DownloadPlatforms.UNKNOWN;

          const dataLayer = ((window["dataLayer"] && window["dataLayer"]) || []);
          dataLayer.push({
            event: "couldNotDeterminePlatformDownload",
            payload: true,
          });
        }
      } else {
        Log.warn("unable to automatically determine download platform");
        platformDesired = DownloadPlatforms.UNKNOWN;

        const dataLayer = (window.dataLayer = window.dataLayer || []);
        dataLayer.push({
          event: "platformInfoNotAvailableDownload",
          payload: true,
        });
      }
    }

    // download!
    if (platformDesired === DownloadPlatforms.MAC) {

      const downloadLink = BBDownloadVersion[version].MAC;
      const downloadType = BBDownloadVersion[version].APP;

      window.location.href = downloadLink;

      const dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({
        event: "macDownload",
        payload: true,
      });

      const savedGoogleClientId = localStorage.getItem("googleClientId");
      sendDownloadAnalytics(savedGoogleClientId, downloadType);

      resolve(downloadLink);
    } else if (platformDesired === DownloadPlatforms.WINDOWS) {

      const downloadLink = BBDownloadVersion[version].WIN;
      const downloadType = BBDownloadVersion[version].APP;

      window.location.href = downloadLink;

      const dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({
        event: "winDownload",
        payload: true,
      });

      const savedGoogleClientId = localStorage.getItem("googleClientId");

      sendDownloadAnalytics(savedGoogleClientId, downloadType);

      resolve(downloadLink);
    } else {
      Log.trace("attempted download on non-mac/win platform");

      const dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({
        event: "unknownPlatformDownload",
        payload: true,
      });

      resolve(false);
    }
  }); // end of promise wrapper
}; // end of downloadBuildboxClient()

// calls the downloads endpoint
const sendDownloadAnalytics = async (googleClientId, version) => {
  try {
    //Log.info(googleClientId, "Downloads Component: send client id");
    //Log.info(version, "Downloads Component: app:", version);

    const analyticsResponse = await createUserDownloadsRequest(
      googleClientId,
      version
    );
    Log.info(
      analyticsResponse,
      "Downloads Component: Response from /createUserDownloadsRequest"
    );
  } catch (error) {
    Log.info(
      error,
      "Downloads Component: Error caught from sendDownloadAnalytics"
    );
  }
};
